export const formatIndianAmount = (value: string) => {
  const digits = String(value || "").replace(/[^\d]/g, "");

  if (!digits) {
    return "";
  }

  if (digits.length <= 3) {
    return digits;
  }

  const lastThree = digits.slice(-3);
  const remaining = digits.slice(0, -3);
  const grouped = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return `${grouped},${lastThree}`;
};
